module.exports = __webpack_public_path__ + "img/dog.124faf4e.svg";